<template>
  <div class="news-headlines-detail">
        <!-- <newsHeader :page='2'></newsHeader> -->
         <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="0"></Header> -->
        <el-breadcrumb separator="/" class="bread-crumb main">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <!-- <el-breadcrumb-item :to="{ path: '/list/information' }">组考单位</el-breadcrumb-item> -->
            <el-breadcrumb-item>{{article.title}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="news-detail-wrapper main flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <h3 class="f18">{{article.title}}</h3>
                        <p class="source f12">{{article.source}}</p>
                        <div class="summary f12 flex-align-between">
                            <div class="box">
                                <span>{{article.createTime}}</span>
                            </div>
                         
                        </div>
                    </div>
                    <div class="content" v-html="article.content">
                        
                    </div>
                 
                   
                </div>
            </div>
           
        </div>
    <footer-view></footer-view>

  </div>
</template>

<script>
export default {
    data() {
        return {
        article:{},
        }
    },
     watch: {
        '$route': function(to,from){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    },
    methods: {
        async GetContent(){
            let params = {
                id : this.$route.params.id,
            }
            let resData = await Api.Home.getDetail(params)
            this.article = resData.data;
         },
        
         
    },
    mounted(){
        this.GetContent();
    },

}
</script>

<style lang="less" scoped>
    @import "./less/news_headlines_detail.less";
</style>